import { render, staticRenderFns } from "./ProductNameSelector.vue?vue&type=template&id=5dac575c&scoped=true&"
import script from "./ProductNameSelector.vue?vue&type=script&lang=js&"
export * from "./ProductNameSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dac575c",
  null
  
)

export default component.exports